import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "text-zink-300 dark:text-zink-500" }, ".", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-zink-300 dark:text-zink-500 mr-px" }, " $ ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "text-zink-300 dark:text-zink-500" }, ".", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalLoadingBlock = _resolveComponent("BalLoadingBlock")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.type === 'token')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_BalLoadingBlock, {
            class: _normalizeClass(_ctx.blockClasses),
            rounded: "sm",
            darker: ""
          }, null, 8, ["class"]),
          _createVNode(_component_BalLoadingBlock, {
            class: _normalizeClass(_ctx.blockClasses),
            rounded: "sm",
            darker: ""
          }, null, 8, ["class"]),
          _hoisted_2,
          _createVNode(_component_BalLoadingBlock, {
            class: _normalizeClass(_ctx.blockClasses),
            rounded: "sm",
            darker: ""
          }, null, 8, ["class"]),
          _createVNode(_component_BalLoadingBlock, {
            class: _normalizeClass(_ctx.blockClasses),
            rounded: "sm",
            darker: ""
          }, null, 8, ["class"]),
          _createVNode(_component_BalLoadingBlock, {
            class: _normalizeClass(_ctx.blockClasses),
            rounded: "sm",
            darker: ""
          }, null, 8, ["class"]),
          _createVNode(_component_BalLoadingBlock, {
            class: _normalizeClass(_ctx.blockClasses),
            rounded: "sm",
            darker: ""
          }, null, 8, ["class"])
        ], 64))
      : (_ctx.type === 'fiat')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_3,
            _createVNode(_component_BalLoadingBlock, {
              class: _normalizeClass(_ctx.blockClasses),
              rounded: "sm",
              darker: ""
            }, null, 8, ["class"]),
            _createVNode(_component_BalLoadingBlock, {
              class: _normalizeClass(_ctx.blockClasses),
              rounded: "sm",
              darker: ""
            }, null, 8, ["class"]),
            _hoisted_4,
            _createVNode(_component_BalLoadingBlock, {
              class: _normalizeClass(_ctx.blockClasses),
              rounded: "sm",
              darker: ""
            }, null, 8, ["class"]),
            _createVNode(_component_BalLoadingBlock, {
              class: _normalizeClass(_ctx.blockClasses),
              rounded: "sm",
              darker: ""
            }, null, 8, ["class"])
          ], 64))
        : _createCommentVNode("", true)
  ]))
}